import { render, staticRenderFns } from "./Bloco.vue?vue&type=template&id=57deb022&scoped=true&"
import script from "./Bloco.vue?vue&type=script&lang=js&"
export * from "./Bloco.vue?vue&type=script&lang=js&"
import style0 from "./Bloco.vue?vue&type=style&index=0&id=57deb022&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57deb022",
  null
  
)

export default component.exports